export default "__VITE_ASSET__CyuHBvBI__"